import * as React from 'react';

import { rgba } from 'polished';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';

import Flex from '@components/layout/flex';
import LockIcon from '@components/basics/icons/lock';
import Typography from '@components/basics/typography';
import UnlockedIcon from '@components/basics/icons/unlocked';

interface CustomDomainProps {
  className?: string;
  isLocked?: boolean;
}

export const CustomDomain: React.FC<CustomDomainProps> = ({
  className,
  isLocked,
}) => {
  return (
    <Flex
      alignItems="center"
      className={`${className} ${isLocked ? 'locked' : ''}`}
    >
      <FlexColumn>
        <LeftWrapper>
          <Typography className="title" weight="700" customSize="14px">
            <Translate id="ARTIST.CREATE.TRACPAGE.CUSTOM.DOMAIN" />
          </Typography>
          <Typography weight="400" customSize="12px" opacity="0.5">
            <Translate id="ARTIST.CREATE.TRACPAGE.CUSTOM.DOMAIN.DESCRIPTION" />
          </Typography>
        </LeftWrapper>
        <Icon className={isLocked ? 'locked-icon' : ''}>
          {isLocked ? <LockIcon /> : <UnlockedIcon />}
        </Icon>
      </FlexColumn>
    </Flex>
  );
};

export default styled(CustomDomain)`
  width: 100%;
  border-radius: 0px 0px 4px 4px;
  background-color: ${({ theme }) => theme.colors.blueColorDark};

  &.locked {
    background-color: ${({ theme }) => theme.colors.blueColor};
  }

  span {
    color: ${({ theme }) => theme.colors.white};
  }

  .title {
    margin-bottom: 5px;
  }
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  width: 100%;
`;

const LeftWrapper = styled.div`
  width: 85%;
`;

const Icon = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  height: 32px;
  width: 32px;
  justify-content: center;
  align-items: center;
  display: flex;

  &.locked-icon {
    background-color: ${({ theme }) => rgba(theme.colors.white, 0.1)};
  }
`;
